// extracted by mini-css-extract-plugin
module.exports = {"SearchResults":"SearchResults_SearchResults__1zDJv"};